import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { CheckCircle2, Loader2 } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { tokenManager } from '@/lib/tokenManager'
import { authApi } from '@/features/auth/api'

export function LogoutPage() {
  const [done, setDone] = useState(false)

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        await authApi.logout()
      } catch {
        /* ignore - best effort */
      }
      try {
        localStorage.removeItem('token')
        localStorage.removeItem('bk.app_jwt')
        localStorage.removeItem('userId')
        localStorage.removeItem('userName')
        localStorage.removeItem('userEmail')
        sessionStorage.removeItem('bk.is_staff')
        sessionStorage.removeItem('bk.super_admin_token')
      } catch {
        /* ignore */
      }
      tokenManager.clear()
      if (!cancelled) setDone(true)
    })()
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-center text-2xl">Signing you out</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 text-center">
        {done ? (
          <CheckCircle2 className="mx-auto size-10 text-success" />
        ) : (
          <Loader2 className="mx-auto size-10 animate-spin text-primary" />
        )}
        <p className="text-sm text-muted-foreground">
          {done ? 'You have been signed out.' : 'Please wait while we revoke your session…'}
        </p>
        <Button asChild className="w-full" disabled={!done}>
          <Link to="/login">Sign in again</Link>
        </Button>
      </CardContent>
    </Card>
  )
}
